<template>
    <!-- <p class="page-container">404 page not found</p> -->
    <div class="body">   
           <img src="../assets/404.png"/>
           <div style="color:#33312D;margin-top:40px;">抱歉，您访问的页面不存在</div>
          <div style="margin-top:70px;"><el-button type="primary" @click="back">返回首页</el-button></div>
            
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        back(){
             this.$router.push({path: '/search'});
        }
    }
    
}
</script>
<style lang="scss" scoped>
.body{text-align: center;padding-top:200px;}
    @import "../styles/404.scss";
</style>


// WEBPACK FOOTER //
// 404.vue?53fc40c4